// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { CREATE_EQUIPMENT, DELETE_EQUIPMENT, GET_DETAIL_EQUIPMENT, GET_LIST_EQUIPMENT, UPDATE_EQUIPMENT } from '~/utils/constants/actionType';
import equipmentApi from '~/apis/equipment';
import { IBodyUpdate } from '~/utils/interface/common';
import { IFormEquipment, IQueryParamEquipment } from '~/utils/interface/equipment';

export const getListEquipment = createAsyncThunk(
  GET_LIST_EQUIPMENT,
  async (params: IQueryParamEquipment, { rejectWithValue }) => {
    try {
      const resp = await equipmentApi.getListEquipment(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailEquipment = createAsyncThunk(GET_DETAIL_EQUIPMENT, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await equipmentApi.getDetailEquipment(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createEquipment = createAsyncThunk(CREATE_EQUIPMENT, async (body: IFormEquipment, { rejectWithValue }) => {
  try {
    const resp = await equipmentApi.createEquipment(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateEquipment = createAsyncThunk(
  UPDATE_EQUIPMENT,
  async (params: IBodyUpdate<IFormEquipment>, { rejectWithValue }) => {
    try {
      const resp = await equipmentApi.updateEquipment(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteEquipment = createAsyncThunk(DELETE_EQUIPMENT, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await equipmentApi.deleteEquipment(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
